import './BackButton.css';
import backButton from '../../img/back-button.svg';
import { useHistory } from 'react-router-dom';

const BackButton = ({ text, goBack }) => {

    const history = useHistory();

    const backButtonHandler = () => {

        if (goBack == "back") {
            history.goBack()
        }
        else {
            history.push("/")
        }

    }

    return (
        <div className="backbutton-outer-wrapper">
            <div onClick={backButtonHandler} className="backbutton-wrapper">
                <img src={backButton}></img>
                <h3>{text}</h3>
            </div>
        </div>
    )
};

export default BackButton;